export function minutesToHHMM(minutes) {
    var hours = Math.floor(minutes / 60);
    var remainingMinutes = minutes % 60;
    var paddedHours = String(hours).padStart(2, '0');
    var paddedMinutes = String(remainingMinutes).padStart(2, '0');
    return "".concat(paddedHours, ":").concat(paddedMinutes);
}
